import { useMatches } from "src/router";

/** Route `handle` for an editor with its own header and way back, which shows no sidebar toggle and no peek. */
export const SIDEBAR_TOGGLE_HIDDEN_ROUTE_HANDLE = {
  sidebarToggle: "hidden",
} as const;

/** Whether a route shows the collapsed sidebar's toggle inline, in its own crumb bar or title row, or hides it. */
export const sidebarToggleModeForMatches = (
  matches: { handle: unknown }[],
): "inline" | "hidden" =>
  matches.some(
    ({ handle }) =>
      typeof handle === "object" &&
      handle !== null &&
      "sidebarToggle" in handle &&
      handle.sidebarToggle === "hidden",
  )
    ? "hidden"
    : "inline";

export const useSidebarToggleMode = () =>
  sidebarToggleModeForMatches(useMatches());
